import React, { useState, useRef } from 'react';
import { NotificationsIcon } from '../../assets';
import { useNotifications } from '../../hooks/notifications/useNotifications';
import VirtualizedNotificationsDropdown from './VirtualizedNotificationsDropdown';
import { useIsMobile } from '../../hooks/useIsMobile';

const NotificationsButton: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showUnreadOnly, setShowUnreadOnly] = useState(true);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const notificationsData = useNotifications({
    filter: showUnreadOnly ? { isRead: false } : undefined,
  });

  const { unreadCount } = notificationsData;
  const isMobile = useIsMobile();

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="flex items-center justify-center w-8 h-8 rounded-ds-default transition-colors hover:bg-ds-bg/50 relative"
        title={isDropdownOpen ? 'Close notifications' : 'Open notifications'}
      >
        {/* Anchored to the icon, not the 32px button, so the badge hugs the bell */}
        <span className="relative inline-flex">
          <img
            src={NotificationsIcon}
            alt="Notifications"
            className="w-4 h-4"
            style={{
              filter:
                'brightness(0) saturate(100%) invert(56%) sepia(6%) saturate(927%) hue-rotate(191deg) brightness(92%) contrast(89%)',
            }}
          />
          {unreadCount > 0 &&
            (isMobile ? (
              // Phones only need to know there is something unread, not how much.
              <>
                <span
                  className="absolute -top-0.5 -right-0.5 h-2 w-2 rounded-full bg-red-500 ring-2 ring-white"
                  aria-hidden="true"
                />
                {/* The dot is visual only — keep the count for screen readers */}
                <span className="sr-only">{unreadCount}</span>
              </>
            ) : (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] rounded-full min-w-[16px] h-4 flex items-center justify-center px-1">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            ))}
        </span>
      </button>
      <VirtualizedNotificationsDropdown
        isOpen={isDropdownOpen}
        onClose={() => setIsDropdownOpen(false)}
        notificationsData={notificationsData}
        showUnreadOnly={showUnreadOnly}
        onToggleFilter={setShowUnreadOnly}
        triggerRef={buttonRef}
      />
    </div>
  );
};

export default NotificationsButton;
